import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './app/routes';
import Header from './components/Header';
import Footer from './components/Footer';
import { useTelegramAutoAuth } from './features/auth/useAutoAuth';
import './App.css';

const AUTH_FREE_PATHS = ['/login', '/register'];

const TelegramSplash: React.FC = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div style={{ opacity: 0.6 }}>Загрузка…</div>
  </div>
);

const AppContent: React.FC = () => {
  const location = useLocation();
  // In the Telegram mini-app this silently signs the user in via initData before
  // the UI renders. In the website build it returns true immediately (no-op).
  const authReady = useTelegramAutoAuth();

  const isAuthFree = AUTH_FREE_PATHS.includes(location.pathname);
  const isAdminRoute = location.pathname.startsWith('/admin');

  // React Router keeps the previous scroll position across route changes, so
  // opening a product from a scrolled feed lands you mid-page. Reset to the top
  // on every navigation.
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  // The storefront (catalog, product pages, etc.) is public — anyone can browse
  // without logging in. Private pages guard themselves via <RequireAuth>, so we
  // no longer force a redirect to /login here.
  const showChrome = !isAdminRoute && !isAuthFree;

  if (!authReady) {
    return (
      <div className="App">
        <TelegramSplash />
      </div>
    );
  }

  return (
    <div className="App">
      {showChrome && (
        <header>
          <Header />
        </header>
      )}
      <AppRoutes />
      {showChrome && <Footer />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
